// src/mixins/globalMixin.js
export default {
  computed: {
    isInvestor() {
      return this.$cookie.get('type') === '投资人';
    },
  },
  methods: {
    handlePreviews(id, freezeStatus) {
      if (this.handleStatus(freezeStatus)) {
        return;
      }
      if (this.$cookie.get('type') === '投资人') {
        return;
      }
      this.imageId = id;
      this.isMyUpload = true;
    },
    handleStatus(freezeStatus) {
      if (freezeStatus === 1) {
        this.$message.warning('该订单已冻结，无法操作');
        return true;
      } else {
        return false;
      }
    },
    /**
     * 根据行数据判断表格行类名
     * @param {Object} row - 表格行数据
     * @param {string} warningField - 用于判断警告状态的字段名，默认为 'is_buy_order_update'
     * @param {*} warningValue - 触发警告的值，默认为 1
     * @returns {string} 类名字符串
     */
    getTableRowClassName(row, warningField = 'is_buy_order_update', warningValue = 1) {
      if (row.row[warningField] === warningValue) {
        return 'warning-row';
      } else {
        return '';
      }
    },
  },
};
